module.exports = __webpack_public_path__ + "img/logo-05.f6acfec4.png";